<template>
  <div
    v-if="dropdownItems.length > 0"
    class="d-flex align-items-center"
  >
    <b-dropdown
      id="dropdown"
      variant="outline-primary"
      :text="dropdownText"
      class="ml-1"
    >
      <b-dropdown-item
        v-for="(item, index) in dropdownItems"
        :key="index"
        @click="handleSelectItem(item)"
      >
        {{ formatDate(item) }}
      </b-dropdown-item>
    </b-dropdown>
    <b-button
      v-if="selectedItem"
      variant="danger"
      class="ml-2 pb-0"
      @click="clearSelection"
    >
      <SvgIcon icon="times-regular" />
    </b-button>
  </div>
  <div v-else>
    {{ $t('components.sidebar.planmodeFilterTags.noParticipationDates') }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SvgIcon from '@/components/common/SvgIcon'

export default {
  name: 'Dropdown',
  components: { SvgIcon },
  data() {
    return {
      dropdownItems: [],
      selectedItem: null,
    }
  },
  computed: {
    ...mapGetters('config', ['participationConfigs']),
    ...mapGetters('access', ['getActiveMunicipality']),
    closingDates(){
      return this.participationConfigs[0].allClosingDates
    },
    dropdownText() {
      return this.selectedItem || this.$i18n.t('components.form.dropdown.selectDate')
    },
  },
  watch: {
    getActiveMunicipality: {
      immediate: true,
      handler (newMun, oldMun) {
        if (newMun !== oldMun) {
          this.initItems()
        }
      },
    },
  },
  methods: {
    initItems() {
      this.dropdownItems = this.closingDates?.sort((a, b) => a.localeCompare(b)) || []
      this.selectedItem = ''
    },
    handleSelectItem(item) {
      this.selectedItem = this.formatDate(item)
      this.$emit('input', item)
    },
    clearSelection() {
      this.selectedItem = ''
      this.$emit('input', '')
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('es-CL')
    },
  },
}
</script>
